import { render, staticRenderFns } from "./TechnicalEfficiency.vue?vue&type=template&id=efcfc3a8&scoped=true"
import script from "./TechnicalEfficiency.vue?vue&type=script&lang=js"
export * from "./TechnicalEfficiency.vue?vue&type=script&lang=js"
import style0 from "./TechnicalEfficiency.vue?vue&type=style&index=0&id=efcfc3a8&prod&lang=scss"
import style1 from "./TechnicalEfficiency.vue?vue&type=style&index=1&id=efcfc3a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efcfc3a8",
  null
  
)

export default component.exports